module.exports = __webpack_public_path__ + "images/emoji/file_folder.a8b571fca84d385435a7.png";